<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-newlead"
      scrollable
      centered
      @hide="hideModal"
      @close="hideModal"
    >
      <RestrictionAlert :personDocument="personDocument" />
      <template #modal-title>
        <i class="fas fa-user-plus"></i> {{ newLeadName }}
      </template>
      <div class="pt-2 pb-4">
        <div class="form-group row">
          <div
            v-if="!isOportunidadeAssociado"
            class="col-md-12"
          >
            <label
              ><small
                class="text-danger"
                v-if="form.documento.required"
                >*</small
              >
              CPF/CNPJ:</label
            >
            <div class="input-group">
              <b-form-input
                autofocus
                type="text"
                ref="documento"
                :placeholder="'Digite o CPF ou CNPJ do Contato'"
                v-model="form.documento.value"
                :size="form.documento.maxlength"
                :required="form.documento.required"
                :state="form.documento.state"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                @blur="onSearchPessoa"
                :disabled="naoDesejaInformarDocumento"
              ></b-form-input>
              <span
                class="input-group-addon"
                @click="onSearchPessoa"
                ><i class="fa fa-search"></i
              ></span>
            </div>
            <b-form-checkbox
              class="pt-2"
              v-model="naoDesejaInformarDocumento"
              :value="true"
              :unchecked-value="false"
            >
              Não informar CPF/CNPJ
            </b-form-checkbox>
          </div>
        </div>
        <div class="form-group row">
          <div
            v-if="isOportunidadeAssociado"
            class="col-md-12"
          >
            <label
              ><small
                class="text-danger"
                v-if="form.documento.required"
                >*</small
              >
              CPF/CNPJ:</label
            >
            <div class="input-group">
              <b-form-input
                autofocus
                type="text"
                ref="documento"
                :placeholder="'Digite o CPF ou CNPJ do Contato'"
                v-model="form.documento.value"
                :size="form.documento.maxlength"
                :required="form.documento.required"
                :state="form.documento.state"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                @blur="onSearchAssociado"
              ></b-form-input>
              <span
                class="input-group-addon"
                @click="onSearchAssociado"
                ><i class="fa fa-search"></i
              ></span>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div
            v-if="isOportunidadeAssociado"
            class="col-md-12"
          >
            <label
              ><small
                class="text-danger"
                v-if="form.name.required"
                >*</small
              >
              Nome:</label
            >
            <div
              id="newLead__container"
              class="input-group flex-nowrap"
            >
              <span class="input-group-addon"><i class="fa fa-user"></i></span>
              <v-select
                label="text"
                v-if="!filledDocument"
                @input="onLoadLeadsAssociados"
                @search="onLoadLeadsAssociados"
                v-model="form.name.selected"
                :options="form.name.listOptions"
                :placeholder="'Digite o Nome do Contato'"
                :required="form.name.required"
                :state="form.name.state"
              >
                <template v-slot:no-options>Nenhum lead encontrado.</template>
              </v-select>
              <b-form-input
                v-if="filledDocument"
                type="text"
                :placeholder="'Digite o Nome do Contato'"
                v-model="form.name.value"
                :required="form.name.required"
                :state="form.name.state"
              ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div
            v-if="!isOportunidadeAssociado"
            class="col-md-12"
          >
            <label
              ><small
                class="text-danger"
                v-if="form.name.required"
                >*</small
              >
              Nome:</label
            >
            <div
              id="newLead__container"
              class="input-group flex-nowrap"
            >
              <span class="input-group-addon"><i class="fa fa-user"></i></span>
              <v-select
                label="text"
                v-if="!filledDocument"
                @input="onLoadLeads"
                @search="onLoadLeads"
                v-model="form.name.selected"
                :options="form.name.listOptions"
                :placeholder="'Digite o Nome do Contato'"
                :required="form.name.required"
                :state="form.name.state"
              >
                <template v-slot:no-options>Nenhum lead encontrado.</template>
              </v-select>
              <b-form-input
                v-if="filledDocument"
                type="text"
                :placeholder="'Digite o Nome do Contato'"
                v-model="form.name.value"
                :required="form.name.required"
                :state="form.name.state"
              ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label
              ><small
                class="text-danger"
                v-if="form.email.required"
                >*</small
              >
              Email:</label
            >
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="fas fa-envelope"></i
              ></span>
              <b-form-input
                type="text"
                :placeholder="'Digite o E-mail do Contato'"
                v-model="form.email.value"
                :size="form.email.maxlength"
                :required="form.email.required"
                :state="form.email.state"
              ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label
              ><small
                class="text-danger"
                v-if="form.telefone.required"
                >*</small
              >
              Telefone:</label
            >
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="fas fa-phone-alt"></i
              ></span>
              <b-form-input
                type="text"
                :placeholder="'Digite o Telefone do Contato'"
                v-model="form.telefone.value"
                :size="form.telefone.maxlength"
                :required="form.telefone.required"
                :state="form.telefone.state"
                v-mask="['(##) ####-####']"
              ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label
              ><small
                class="text-danger"
                v-if="form.celular.required"
                >*</small
              >
              Celular:</label
            >
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="fas fa-mobile"></i
              ></span>
              <b-form-input
                type="text"
                :placeholder="'Digite o Telefone do Contato'"
                v-model="form.celular.value"
                :size="form.celular.maxlength"
                :required="form.celular.required"
                :state="form.celular.state"
                v-mask="['(##) # ####-####']"
              ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label for="txtGroup"
              ><small
                class="text-danger"
                v-if="form.leadOriginID.required"
                >*</small
              >
              Origem:</label
            >
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="fas fa-bullhorn"></i
              ></span>
              <b-form-select
                v-model="form.leadOriginID.value"
                :options="form.leadOriginID.options"
              >
                <template slot="first">
                  <option :value="null">
                    {{ $lang.Common.PlaceholderSelect }}
                  </option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            @click.prevent="clearForms"
            :disabled="buttonDisabled"
            type="button"
            class="btn rounded btn-default btn-sm"
            v-b-tooltip.hover
            :title="'Limpar Campos'"
          >
            <i class="fas fa-trash mr-1"></i>
            <span class="d-md-down-none">Limpar Campos</span>
          </button>
          <button
            @click.prevent="onSave"
            :disabled="buttonDisabled"
            type="button"
            class="btn rounded btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Salvar'"
          >
            <i class="fas fa-check-circle mr-1"></i>
            <span class="d-md-down-none">Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import NewLead from './newlead.js'
export default NewLead
</script>

<!-- .disabled {
  pointer-events:none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
} -->
<style lang="scss">
#newLead__container {
  .v-select > #vs1__combobox,
  .v-select > #vs2__combobox,
  .vs__dropdown-toggle {
    border-radius: 0 4px 4px 0 !important;
  }

  .v-select {
    flex: 1 1 auto;
    background: #fff
      url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat right 0.75rem center;
    background-size: 8px 10px;
  }

  .v-select input {
    padding: 2px 1rem;
    font-size: 13px;
    line-height: 1.25;
    background-clip: padding-box;
    color: #b0bec5;
  }

  .vs__selected-options {
    color: #607d8b;
  }

  .vs__actions {
    display: none;
  }

  #vs1__combobox,
  #vs2__combobox {
    border-radius: 0 !important;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  #vs1__listbox,
  .vs__selected {
    color: #607d8b;
    font-size: 13px;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/new/newlead.vue